/* eslint-disable no-console */
import React, { useCallback, useEffect, useState } from 'react'
import { ContentComponentType } from '@splunk-iteng/splunk-shared-components/dist/lib/Types/ContentComponentType'
import { useIssueAccountActivationEmailMutation } from '../../graphql/graphql'

export function SendActivationEmail({
  currentState,
  doSubmit,
  clearState
}: ContentComponentType) {
  const [email, setEmail] = useState(currentState?.email)
  const [localDoSubmit, setLocalDoSubmit] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [successData, setSuccessData] = useState({} as any)
  const [issueAccountActivationEmailMutation] =
    useIssueAccountActivationEmailMutation()
  const [emailHasChanged, setEmailHasChanged] = useState(false)

  useEffect(() => {
    if (currentState.email !== email) {
      setEmail(currentState.email)
      setEmailHasChanged(true)
    }
  }, [email, currentState.email])

  const submit = useCallback(async () => {
    try {
      if (emailHasChanged) {
        setSubmitted(false)
        setSubmitting(true)
        const { data }: any = await issueAccountActivationEmailMutation({
          variables: {
            username: email
          },
          onError: (err) => {
            const message = err.message.search('Must be in email format')
            if (message >= 0) {
              alert('Please provide a value with a valid email format')
            } else {
              alert(err.message)
            }
          }
        })
        setSuccessData(data)
        setSubmitting(false)
        setSubmitted(true)
      }
    } catch (error) {
      setSuccessData({})
      setSubmitting(false)
      setSubmitted(true)
    } finally {
      clearState()
    }
  }, [email, emailHasChanged, issueAccountActivationEmailMutation, clearState])

  const btn = (label = 'Send activation email') => (
    <button
      type="button"
      className="mt-20 btn btn-primary"
      onClick={submit}
      disabled={submitting || !email}
    >
      {label}
    </button>
  )

  useEffect(() => {
    if (doSubmit && !localDoSubmit) {
      setLocalDoSubmit(true)
      submit()
    }
    if (!doSubmit) setLocalDoSubmit(false)
  }, [doSubmit, localDoSubmit, submit])

  useEffect(() => {
    if (!doSubmit) setLocalDoSubmit(false)
  }, [doSubmit, localDoSubmit])

  if (submitting) {
    return <div className="p-20">Sending activation Link...</div>
  }

  if (
    submitted &&
    email &&
    emailHasChanged &&
    (!successData ||
      !successData.issueAccountActivationEmail ||
      !successData.issueAccountActivationEmail.activationEmailSent)
  ) {
    return (
      <div className="p-20">
        Failed to send activation link to {email}
        <br />
        {btn('Retry')}
      </div>
    )
  }

  if (
    submitted &&
    successData &&
    successData.issueAccountActivationEmail &&
    successData.issueAccountActivationEmail.activationEmailSent
  ) {
    return (
      <div className="row">
        <div className="col-12">
          User {email} activation link was successfully sent
          <br />
          {btn('Send another one')}
        </div>
      </div>
    )
  }

  return (
    <div className="p-20">
      Please enter username to send activation Link.
      <br />
      {btn()}
    </div>
  )
}
